// extracted by mini-css-extract-plugin
export default {"general":"settingsForm_general__tYDUN","submitButton":"settingsForm_submitButton__aIplF"};